// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-container{margin-bottom:80px;margin-top:100px}.success-container .success-image{width:100%;max-height:300px}.success-container h1{font-size:45px;color:#46aeff;margin-bottom:25px}.success-container p{margin:0;font-size:17px;color:#46aeff}.success-container button{background-color:#ff5964;color:#fafafa;border-radius:3px;padding:10px 28px;border:0;margin-top:37px;font-size:16px}", ""]);
// Exports
module.exports = exports;
